module.exports = __webpack_public_path__ + "img/usdt-icon.84c62e1f.png";